import type { JSX } from "react";

import { cn } from "@/lib/utils";

export function CountBadge({
  count,
  className,
}: {
  readonly count: number;
  readonly className?: string;
}): JSX.Element | null {
  if (count <= 0) {
    return null;
  }

  return (
    <span
      className={cn(
        "ml-0.5 bg-primary text-primary-foreground rounded-full h-4 sm:h-5 min-w-[16px] sm:min-w-[20px] px-1 sm:px-1.5 flex items-center justify-center text-[10px] sm:text-xs font-semibold",
        className,
      )}
    >
      {count}
    </span>
  );
}
